/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import { type CalendarBasedStrategyConfig, CalendarBasedStrategyConfigFromJSONTyped, CalendarBasedStrategyConfigToJSON, CalendarBasedStrategyConfigToJSONTyped } from './CalendarBasedStrategyConfig';
import { type ConfigurationBasedStrategyConfig, ConfigurationBasedStrategyConfigFromJSONTyped, ConfigurationBasedStrategyConfigToJSON, ConfigurationBasedStrategyConfigToJSONTyped } from './ConfigurationBasedStrategyConfig';
/**
 * 
 * @export
 * @interface SchedulingStrategyConfig
 */
export interface SchedulingStrategyConfig {
    /**
     * 
     * @type {string}
     * @memberof SchedulingStrategyConfig
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof SchedulingStrategyConfig
     */
    advanceBookingDays: number;
    /**
     * 
     * @type {Date}
     * @memberof SchedulingStrategyConfig
     */
    lastBookableDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof SchedulingStrategyConfig
     */
    type: string;
}

/**
 * Check if a given object implements the SchedulingStrategyConfig interface.
 */
export function instanceOfSchedulingStrategyConfig(value: object): value is SchedulingStrategyConfig {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('advanceBookingDays' in value) || value['advanceBookingDays'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function SchedulingStrategyConfigFromJSON(json: any): SchedulingStrategyConfig {
    return SchedulingStrategyConfigFromJSONTyped(json, false);
}

export function SchedulingStrategyConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): SchedulingStrategyConfig {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json['type'] === 'CalendarBasedStrategyConfig') {
            return CalendarBasedStrategyConfigFromJSONTyped(json, ignoreDiscriminator);
        }
        if (json['type'] === 'ConfigurationBasedStrategyConfig') {
            return ConfigurationBasedStrategyConfigFromJSONTyped(json, ignoreDiscriminator);
        }

    }
    return {
        
        'id': json['id'],
        'advanceBookingDays': json['advanceBookingDays'],
        'lastBookableDate': json['lastBookableDate'] == null ? undefined : (new Date(json['lastBookableDate'])),
        'type': json['type'],
    };
}

export function SchedulingStrategyConfigToJSON(json: any): SchedulingStrategyConfig {
    return SchedulingStrategyConfigToJSONTyped(json, false);
}

export function SchedulingStrategyConfigToJSONTyped(value?: SchedulingStrategyConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (!ignoreDiscriminator) {
        switch (value['type']) {
            case 'CalendarBasedStrategyConfig':
                return CalendarBasedStrategyConfigToJSONTyped(value as CalendarBasedStrategyConfig, ignoreDiscriminator);
            case 'ConfigurationBasedStrategyConfig':
                return ConfigurationBasedStrategyConfigToJSONTyped(value as ConfigurationBasedStrategyConfig, ignoreDiscriminator);
            default:
                return value;
        }
    }

    return {
        
        'id': value['id'],
        'advanceBookingDays': value['advanceBookingDays'],
        'lastBookableDate': value['lastBookableDate'] == null ? value['lastBookableDate'] : value['lastBookableDate'].toISOString(),
        'type': value['type'],
    };
}

